import type { Pluggable } from 'unified';
import rehypeSanitize, { defaultSchema } from 'rehype-sanitize';
import { defaultRehypePlugins } from 'streamdown';

/**
 * Custom rehype plugins that extend the sanitization schema to allow the
 * `copilot-file` protocol in links. This lets the agent emit
 * `[filename](copilot-file://path)` links that survive sanitization natively,
 * instead of requiring preprocessing to rewrite them as fragment links.
 *
 * We build the schema from rehype-sanitize's `defaultSchema` and replicate
 * streamdown's `tel` protocol addition (its only customization as of v2.3)
 * rather than destructuring `defaultRehypePlugins.sanitize`, which is typed
 * as `Pluggable` and would require an unsafe cast to extract the schema.
 */
const sanitizeSchema = {
  ...defaultSchema,
  protocols: {
    ...defaultSchema.protocols,
    href: [...(defaultSchema.protocols?.href ?? []), 'tel', 'copilot-file'],
  },
};

export const copilotFileRehypePlugins: Pluggable[] = [
  defaultRehypePlugins.raw,
  [rehypeSanitize, sanitizeSchema] as Pluggable,
  defaultRehypePlugins.harden,
];
